import {type TaskChecklist} from '@domain/hroc-checklists'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

export const TaskChecklistsQueryKey = 'task-checklists'

type Params = {
  plantId: string
  taskId: string | undefined
  options?: Omit<UseQueryOptions<TaskChecklist[], AxiosError>, 'queryKey'>
}

export const useTaskChecklists = ({plantId, taskId, options}: Params) => {
  const path = `/hroc-checklists/api/${plantId}/checklists/for-task/${taskId}`

  return useQuery<TaskChecklist[], AxiosError>({
    queryKey: [TaskChecklistsQueryKey, plantId, taskId],
    queryFn: async () => {
      const response = await ApiClient.axiosInstance.get<TaskChecklist[]>(path)
      return response.data
    },
    ...options
  })
}
